export default __webpack_public_path__ + "static/media/tele.1422dcf1.png";